// ns
import consumer from "./index"

const subscriptions = {}

function updateTabBadge(roomId, count) {
  const tabButton = document.querySelector('.tab-button[data-room-id="' + roomId + '"]')
  if (!tabButton) return

  let badge = tabButton.querySelector('.od-tab-badge')
  if (count > 0) {
    if (!badge) {
      badge = document.createElement('span')
      badge.className = 'od-tab-badge'
      badge.title = 'Object detection reports'
      tabButton.appendChild(badge)
    }
    badge.textContent = String(count)
  } else if (badge) {
    badge.remove()
  }
}

function unsubscribeAll() {
  Object.keys(subscriptions).forEach(function(roomId) {
    subscriptions[roomId].unsubscribe()
    delete subscriptions[roomId]
  })
}

function activeCategories(root) {
  return Array.from(root.querySelectorAll('.od-category-filter'))
    .filter(function(button) { return button.getAttribute('aria-pressed') === 'true' })
    .map(function(button) { return button.getAttribute('data-od-filter-category') })
}

function applyCategoryFilters(root) {
  if (!root) return

  const selected = activeCategories(root)
  const showAll = selected.length === 0
  const clearButton = root.querySelector('.od-category-panel__clear')

  root.querySelectorAll('.od-category-filter').forEach(function(button) {
    const isActive = button.getAttribute('aria-pressed') === 'true'
    button.classList.toggle('od-category-filter--active', isActive)
  })

  root.querySelectorAll('.od-category-matrix__row').forEach(function(row) {
    const category = row.getAttribute('data-od-category-row')
    row.classList.toggle('od-category-matrix__row--active', !showAll && selected.indexOf(category) !== -1)
  })

  root.querySelectorAll('.od-object-card').forEach(function(card) {
    const category = card.getAttribute('data-od-category')
    const visible = showAll || selected.indexOf(category) !== -1
    card.classList.toggle('od-object-card--filtered-out', !visible)
  })

  root.querySelectorAll('.od-report-card').forEach(function(reportCard) {
    const objectCards = reportCard.querySelectorAll('.od-object-card')
    const visibleCount = Array.from(objectCards).filter(function(card) {
      return !card.classList.contains('od-object-card--filtered-out')
    }).length
    const countEl = reportCard.querySelector('[data-od-report-visible-count]')
    const totalCount = parseInt(
      (countEl && countEl.getAttribute('data-od-report-total-count')) || objectCards.length,
      10
    )
    const filterEmptyEl = reportCard.querySelector('[data-od-report-filter-empty]')
    const objectsList = reportCard.querySelector('.od-objects-list')
    const hasFilter = !showAll

    if (countEl) {
      const label = visibleCount === 1 ? 'object' : 'objects'
      if (hasFilter && visibleCount !== totalCount) {
        countEl.textContent = visibleCount + ' of ' + totalCount + ' ' + label
      } else {
        countEl.textContent = totalCount + ' ' + label
      }
    }

    if (filterEmptyEl && objectsList) {
      const showFilterEmpty = hasFilter && totalCount > 0 && visibleCount === 0
      filterEmptyEl.hidden = !showFilterEmpty
      objectsList.hidden = showFilterEmpty
    }

    reportCard.classList.toggle(
      'od-report-card--filtered-out',
      hasFilter && totalCount > 0 && visibleCount === 0
    )
  })

  if (clearButton) clearButton.hidden = showAll
}

function bootCategoryFilters(root) {
  if (!root) return

  if (root.querySelector('.od-category-filter') && root.dataset.odFiltersBooted !== 'true') {
    root.dataset.odFiltersBooted = 'true'
    root.addEventListener('click', function(event) {
      const filterBtn = event.target.closest('.od-category-filter')
      if (filterBtn && root.contains(filterBtn)) {
        event.preventDefault()
        const isPressed = filterBtn.getAttribute('aria-pressed') === 'true'
        filterBtn.setAttribute('aria-pressed', isPressed ? 'false' : 'true')
        applyCategoryFilters(root)
        return
      }

      const clearBtn = event.target.closest('.od-category-panel__clear')
      if (clearBtn && root.contains(clearBtn)) {
        event.preventDefault()
        root.querySelectorAll('.od-category-filter').forEach(function(button) {
          button.setAttribute('aria-pressed', 'false')
        })
        applyCategoryFilters(root)
      }
    })
  }

  applyCategoryFilters(root)
}

function bootAllCategoryFilters() {
  document.querySelectorAll('.od-reports-root[data-room-id]').forEach(bootCategoryFilters)
}

const OBJECT_FORM_FIELDS = ['name', 'category', 'type', 'quantity', 'confidence']

function objectFormUrl(auditId, roomId, reportId, objectId) {
  let url = '/admin/audits/' + auditId + '/rooms/' + roomId +
    '/object_detection_reports/' + reportId + '/detected_objects'
  if (objectId) url += '/' + objectId
  return url
}

function setObjectFormMethod(form, method) {
  let methodField = form.querySelector('input[name="_method"]')
  if (method === 'patch') {
    if (!methodField) {
      methodField = document.createElement('input')
      methodField.type = 'hidden'
      methodField.name = '_method'
      form.appendChild(methodField)
    }
    methodField.value = 'patch'
  } else if (methodField) {
    methodField.remove()
  }
}

function applyImageRotation(imageEl, rotation) {
  if (!imageEl) return

  const normalized = ((parseInt(rotation, 10) || 0) % 360 + 360) % 360
  imageEl.dataset.rotation = String(normalized)
  imageEl.style.transform = normalized ? 'rotate(' + normalized + 'deg)' : ''
}

function rotateImageUrl(auditId, roomId, reportId, objectId) {
  return '/admin/audits/' + auditId + '/rooms/' + roomId +
    '/object_detection_reports/' + reportId + '/detected_objects/' + objectId + '/rotate_image'
}

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : ''
}

function persistImageRotation(button, direction) {
  const auditId = button.getAttribute('data-audit-id')
  const roomId = button.getAttribute('data-room-id')
  const reportId = button.getAttribute('data-report-id')
  const objectId = button.getAttribute('data-object-id')
  const frame = button.closest('.od-object-card__image-frame')
  const imageEl = frame && frame.querySelector('[data-od-rotatable-image]')
  if (!imageEl || !auditId || !roomId || !reportId || !objectId) return

  const controls = frame.querySelector('.od-object-card__image-controls')
  if (controls) controls.querySelectorAll('button').forEach(function(btn) { btn.disabled = true })

  fetch(rotateImageUrl(auditId, roomId, reportId, objectId), {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': csrfToken()
    },
    body: JSON.stringify({ direction: direction }),
    credentials: 'same-origin'
  }).then(function(response) {
    return response.json().then(function(data) {
      if (!response.ok || !data.success) throw new Error('rotate failed')
      applyImageRotation(imageEl, data.image_rotation)
    })
  }).catch(function() {
    window.alert('Unable to rotate image. Please try again.')
  }).finally(function() {
    if (controls) controls.querySelectorAll('button').forEach(function(btn) { btn.disabled = false })
  })
}

function rotateModalImage(button) {
  const form = button.closest('.od-object-form')
  const imageEl = form && form.querySelector('[data-od-rotatable-image]')
  const preservedField = form && form.querySelector('.od-preserved-attributes-json')
  if (!imageEl) return

  const direction = button.getAttribute('data-od-rotate-image-modal') === 'ccw' ? -90 : 90
  const current = parseInt(imageEl.dataset.rotation || '0', 10) || 0
  const next = (current + direction + 360) % 360
  applyImageRotation(imageEl, next)

  if (preservedField) {
    let preserved = {}
    try {
      preserved = JSON.parse(preservedField.value || '{}')
    } catch (e) {
      preserved = {}
    }
    preserved.image_rotation = next
    preservedField.value = JSON.stringify(preserved)
  }
}

function populateObjectForm(form, payload) {
  const source = payload || {}
  const preserved = Object.assign({}, source)
  OBJECT_FORM_FIELDS.forEach(function(key) {
    delete preserved[key]
    const input = form.querySelector('[name="detected_object[' + key + ']"]')
    if (!input) return
    const value = source[key]
    input.value = value == null ? '' : String(value)
  })
  delete preserved.catalogue_matches
  delete preserved.image_url

  const imagePreview = form.querySelector('.od-object-form__image-preview')
  const imageEl = form.querySelector('.od-object-form__image')
  const imageUrl = source.image_url
  if (imagePreview && imageEl) {
    if (imageUrl) {
      imageEl.src = imageUrl
      imageEl.alt = source.name || 'Detected object'
      applyImageRotation(imageEl, source.image_rotation || 0)
      imagePreview.hidden = false
    } else {
      imagePreview.hidden = true
      imageEl.removeAttribute('src')
      imageEl.alt = ''
      applyImageRotation(imageEl, 0)
    }
  }

  const preservedField = form.querySelector('.od-preserved-attributes-json')
  if (preservedField) preservedField.value = JSON.stringify(preserved)
}

function getSubmitButtonLabel(submit) {
  if (submit.tagName === 'BUTTON') return submit.textContent.trim()
  return submit.value
}

function setSubmitButtonLabel(submit, label) {
  if (submit.tagName === 'BUTTON') {
    submit.textContent = label
  } else {
    submit.value = label
  }
}

function setObjectFormSubmitting(form, submitting) {
  const submit = form.querySelector('[type="submit"]')
  if (!submit) return

  if (submitting) {
    if (!submit.dataset.odOriginalValue) {
      submit.dataset.odOriginalValue = getSubmitButtonLabel(submit)
    }
    const isUpdate = submit.dataset.odOriginalValue === 'Update object'
    setSubmitButtonLabel(submit, isUpdate ? 'Updating...' : 'Saving...')
    submit.disabled = true
    submit.setAttribute('aria-busy', 'true')
  } else {
    submit.disabled = false
    submit.removeAttribute('aria-busy')
    if (submit.dataset.odOriginalValue) {
      setSubmitButtonLabel(submit, submit.dataset.odOriginalValue)
    }
  }
}

function openObjectModal(roomId, options) {
  const modal = document.getElementById('od-object-modal-' + roomId)
  const form = document.getElementById('od-object-form-' + roomId)
  const title = modal && modal.querySelector('.od-modal__title')
  if (!modal || !form) return

  const auditId = options.auditId
  const reportId = options.reportId
  const objectId = options.objectId
  const isEdit = !!objectId

  form.action = objectFormUrl(auditId, roomId, reportId, objectId)
  setObjectFormMethod(form, isEdit ? 'patch' : 'post')
  populateObjectForm(form, options.payload || {})

  if (title) title.textContent = isEdit ? 'Edit object' : 'Add object'

  const submit = form.querySelector('[type="submit"]')
  if (submit) {
    const label = isEdit ? 'Update object' : 'Save object'
    submit.disabled = false
    submit.removeAttribute('aria-busy')
    setSubmitButtonLabel(submit, label)
    submit.dataset.odOriginalValue = label
  }

  modal.hidden = false
  document.body.classList.add('od-modal-open')
}

function closeObjectModals() {
  document.querySelectorAll('.od-modal').forEach(function(modal) {
    modal.hidden = true
  })
  document.body.classList.remove('od-modal-open')
}

function toggleAddReportForm(roomId) {
  const panel = document.getElementById('od-add-report-' + roomId)
  if (!panel) return
  panel.hidden = !panel.hidden
}

function bootObjectManagement() {
  const roomsRoot = document.querySelector('.rooms-content')
  if (!roomsRoot || roomsRoot.dataset.odManagementBooted === 'true') return

  roomsRoot.dataset.odManagementBooted = 'true'

  roomsRoot.addEventListener('submit', function(event) {
    const form = event.target.closest('.od-object-form')
    if (!form || !roomsRoot.contains(form)) return
    if (!form.checkValidity()) return

    setObjectFormSubmitting(form, true)
  })

  roomsRoot.addEventListener('click', function(event) {
    const closeBtn = event.target.closest('[data-od-close-modal]')
    if (closeBtn) {
      event.preventDefault()
      closeObjectModals()
      return
    }

    const toggleReportBtn = event.target.closest('[data-od-toggle-add-report]')
    if (toggleReportBtn) {
      event.preventDefault()
      toggleAddReportForm(toggleReportBtn.getAttribute('data-od-toggle-add-report'))
      return
    }

    const addObjectBtn = event.target.closest('[data-od-add-object]')
    if (addObjectBtn) {
      event.preventDefault()
      openObjectModal(addObjectBtn.getAttribute('data-room-id'), {
        auditId: addObjectBtn.getAttribute('data-audit-id'),
        reportId: addObjectBtn.getAttribute('data-report-id')
      })
      return
    }

    const editObjectBtn = event.target.closest('[data-od-edit-object]')
    if (editObjectBtn) {
      event.preventDefault()
      let payload = {}
      try {
        payload = JSON.parse(editObjectBtn.getAttribute('data-object-payload') || '{}')
      } catch (e) {
        payload = {}
      }
      openObjectModal(editObjectBtn.getAttribute('data-room-id'), {
        auditId: editObjectBtn.getAttribute('data-audit-id'),
        reportId: editObjectBtn.getAttribute('data-report-id'),
        objectId: editObjectBtn.getAttribute('data-object-id'),
        payload: payload
      })
      return
    }

    const rotateCardBtn = event.target.closest('[data-od-rotate-image]')
    if (rotateCardBtn) {
      event.preventDefault()
      event.stopPropagation()
      persistImageRotation(rotateCardBtn, rotateCardBtn.getAttribute('data-od-rotate-image'))
      return
    }

    const rotateModalBtn = event.target.closest('[data-od-rotate-image-modal]')
    if (rotateModalBtn) {
      event.preventDefault()
      rotateModalImage(rotateModalBtn)
    }
  })

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') closeObjectModals()
  })
}

document.addEventListener("turbolinks:load", bootAllCategoryFilters)
document.addEventListener("turbolinks:load", bootObjectManagement)

document.addEventListener("turbolinks:load", function() {
  const roomsRoot = document.querySelector(".rooms-content")
  if (!roomsRoot) return

  unsubscribeAll()

  document.querySelectorAll(".od-reports-root[data-room-id]").forEach(function(root) {
    const roomId = root.getAttribute("data-room-id")
    if (!roomId || subscriptions[roomId]) return

    subscriptions[roomId] = consumer.subscriptions.create(
      {
        channel: "ObjectDetectionReportsChannel",
        room_id: roomId
      },
      {
        received: function(data) {
          if (!data || String(data.room_id) !== String(roomId)) return

          const target = document.querySelector('.od-reports-root[data-room-id="' + roomId + '"]')
          if (!target || data.reports_html == null) return

          target.innerHTML = data.reports_html
          bootCategoryFilters(target)
          if (data.reports_count != null) {
            updateTabBadge(roomId, data.reports_count)
          }
        }
      }
    )
  })
})

document.addEventListener("turbolinks:before-cache", function() {
  unsubscribeAll()
  const roomsRoot = document.querySelector('.rooms-content')
  if (roomsRoot) delete roomsRoot.dataset.odManagementBooted
})
document.addEventListener("turbolinks:before-render", unsubscribeAll)
